import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { CustomEvents } from 'shared/constants/customEvents'
import { useHistory, useUserCompanies, useUserContext } from 'shared/hooks'
import { useRouteCheck } from 'shared/hooks/useRouteCheck'
import { User } from 'shared/types/user'
import { dispatchCustomEvent } from 'shared/utils/customEvents'

import { useAvailableApps } from '../hooks/useAvailableApps'

const ClusterFilesApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const isPublic = useRouteCheck('/public')
  const { apps } = useAvailableApps()
  const { selectedCompany } = useUserCompanies()
  const history = useHistory()

  return (
    <FullPageAppTemplate
      {...(isPublic
        ? { skipPermissionCheck: true }
        : { appId: AppId.CLUSTER_FILES })}
      scope='cluster_files'
      envKey={apps[AppId.CLUSTER_FILES].runtimeEnvKey}
      entryPath='./ClusterFilesApp'
      url={process.env.REACT_APP_CLUSTER_FILES_APP_DEV_PATH}
      hasFullHeight
      appName={apps[AppId.CLUSTER_FILES].name}
      appProps={{
        user,
        initialPath: `${isPublic ? '/public' : ''}${
          apps[AppId.CLUSTER_FILES].path
        }`,
        isPublic,
        organizationName: selectedCompany?.name || '-',
        defaultHistory: history,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        },
        // With only a token, the container validates it against the auth
        // service (/checkToken) as before. When the remote also supplies
        // `user`, the token came from the remote's own backend: the container
        // adopts that user as-is and skips auth-service validation entirely.
        onLogin: (data: {
          access_token: string
          refresh_token?: string
          user?: User
        }) => {
          dispatchCustomEvent(CustomEvents.AUTH_TOKEN_UPDATED, {
            access_token: data.access_token,
            refresh_token: data.refresh_token ?? '',
            redirectRoute: false,
            ...(data.user ? { externalUser: data.user } : {})
          })
        }
      }}
    />
  )
}

export { ClusterFilesApp }
